import script from "./PGHeaderActionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PGHeaderActionButton.vue?vue&type=script&setup=true&lang=js"

import "./PGHeaderActionButton.vue?vue&type=style&index=0&id=73979241&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73979241"]])

export default __exports__